import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EventApi from "../services/event";
import { addData, getData } from "../db";

function useEventInfo() {
    const [eventData, setEventData] = useState(null);
    const [eventDataCache, setEventDataCache] = useState(null);

    const addToDb = async (data) => {
        addData("eventData", data);
    };

    const getFromDb = async (id) => {
        return await getData("eventData", id);
    };

    const fetchEventById = async (id) => {
        try {
            console.log("getting event data");
            let response = await EventApi.getEvent(id);
            if (response?.data?.data) {
                const fetchedEventData = response.data.data;
                setEventData(fetchedEventData);
                await addToDb(fetchedEventData);
                return fetchedEventData;
            }
        } catch (error) {
            console.error("Error fetching event data:", error);
            toast.error("Erro ao buscar dados do evento");
        }
    };

    return {
        eventDataCache,
        eventData,
        setEventData,
        fetchEventById,
    };
}

export default useEventInfo;
